import { renderContentProps } from "./types";
import ReactPlayer from "react-player";
import { NormalMessage, NormalMessageProps } from "./normal-message";
import { cn } from "@/lib/utils";

type Props = Pick<renderContentProps, "attachment"> & NormalMessageProps;

export const FbComment = (props: Props): JSX.Element => {
  return (
    <>
      <AttachmentView attachment={props.attachment} isLeft={props.isLeft} />
      <NormalMessage {...props} />
    </>
  );
};

const AttachmentView = ({
  attachment,
  isLeft,
}: Pick<renderContentProps, "attachment" | "isLeft">) => {
  if (!attachment) {
    return null;
  }
  if (
    attachment.media?.source &&
    (attachment.type.includes("video") ||
      attachment.type.includes("animated_image"))
  ) {
    return (
      <div
        className={cn("mx-4 w-[200px] h-[200px]", !isLeft && "self-end")}
        data-testid="attachment-video"
      >
        <ReactPlayer
          src={attachment.media?.source}
          width="200px"
          height="200px"
          controls
        />
      </div>
    );
  }
  if (attachment.media?.image?.src) {
    return (
      <img
        className={cn(
          "w-[200px] h-[200px] bg-inbox-surface-sunken shrink-0 object-contain mx-4",
          !isLeft && "self-end"
        )}
        alt="Attachment Preview Image"
        src={attachment.media?.image?.src}
      />
    );
  }
  return null;
};
